import { createClient } from "@sanity/client";
import ImageUrlBuilder from "@sanity/image-url";

export const sanityClient = createClient({
  projectId: "qhw5zlf9",
  dataset: "production",
  apiVersion: "2023-03-28",
  useCdn: false,
  token:
    "sk6CdhLc8Ubcf2x4YEaOU2U27p2R6AqUwzSdn3JkawrMSAuFiFeqhzForJUqvHDjIcXbYhFClhVfU9GwUMKosP3gPR1UPtNUxuWeQnou1YmzGQXuIQY6jmzRpwZA89RQuMhUCZTwSSwiVitWxEnEc6e0okfaA28XOvvAMLKgXPdTj3eie5Da",
});

const builder = ImageUrlBuilder(sanityClient);

export function urlFor(source) {
  return builder.image(source);
}
